export default "__VITE_ASSET__9cca85e5__"